import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type BidLandscapeProps = IconComponentBaseProps;

export const BidLandscape = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[6],
}: BidLandscapeProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_5052_105361"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5052_105361)">
        <path
          d="M3.53915 13.6668C3.20237 13.6668 2.91732 13.5502 2.68398 13.3168C2.45065 13.0835 2.33398 12.7984 2.33398 12.4617V3.53866C2.33398 3.20188 2.45065 2.91683 2.68398 2.6835C2.91732 2.45016 3.20237 2.3335 3.53915 2.3335H12.4622C12.7989 2.3335 13.084 2.45016 13.3173 2.6835C13.5507 2.91683 13.6673 3.20188 13.6673 3.53866V12.4617C13.6673 12.7984 13.5507 13.0835 13.3173 13.3168C13.084 13.5502 12.7989 13.6668 12.4622 13.6668H3.53915ZM3.33398 11.0565V12.4617C3.33398 12.513 3.35537 12.56 3.39815 12.6027C3.44082 12.6454 3.48782 12.6668 3.53915 12.6668H12.4622C12.5135 12.6668 12.5605 12.6454 12.6032 12.6027C12.6459 12.56 12.6673 12.513 12.6673 12.4617V6.6155L9.18648 10.5245C9.07282 10.6562 8.92948 10.7237 8.75648 10.727C8.58337 10.7304 8.43654 10.6719 8.31598 10.5515L6.07765 8.313L3.33398 11.0565ZM3.33398 9.631L5.65582 7.30916C5.77626 7.18861 5.91687 7.12833 6.07765 7.12833C6.23832 7.12833 6.37887 7.18861 6.49932 7.30916L8.72382 9.5335L12.6673 5.1155V3.53866C12.6673 3.48733 12.6459 3.44033 12.6032 3.39766C12.5605 3.35488 12.5135 3.3335 12.4622 3.3335H3.53915C3.48782 3.3335 3.44082 3.35488 3.39815 3.39766C3.35537 3.44033 3.33398 3.48733 3.33398 3.53866V9.631ZM3.33398 6.6155V5.1155V9.5335V6.88733V11.0565V8.313V11.0002V6.6155ZM3.33398 9.631V3.3335V9.5335V6.88733V9.631ZM3.33398 11.0565V8.313V11.0002V6.6155V12.6668V11.0565Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
